import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ScoringButton = ({
  isLoading,
  coiUpdateInProgress,
  hasPendingCOI,
  trainingCompleted,
  handleStartScoring,
}) => {
  const getButtonText = () => {
    if (isLoading) return 'Loading data...';
    if (coiUpdateInProgress) return 'Updating COI data...';
    if (hasPendingCOI) return 'Complete COI Declarations to Score';
    if (!trainingCompleted)
      return 'Unconscious Bias Training Required to Score';
    return 'Score Candidates';
  };

  const getButtonVariant = () => {
    if (hasPendingCOI) return 'danger';
    if (coiUpdateInProgress || isLoading) return 'secondary';
    return 'primary';
  };

  const getButtonIcon = () => {
    if (isLoading) return 'fa-sync fa-spin';
    if (coiUpdateInProgress) return 'fa-sync fa-spin';
    if (hasPendingCOI) return 'fa-exclamation-triangle';
    return 'fa-clipboard-list';
  };

  const isButtonDisabled = () =>
    isLoading || hasPendingCOI || coiUpdateInProgress;

  return (
    <div className="d-flex justify-content-center mt-xl-5 mb-4">
      <Button
        variant={getButtonVariant()}
        onClick={handleStartScoring}
        disabled={isButtonDisabled()}
        className="d-flex align-items-center gap-2"
      >
        <i className={`fas ${getButtonIcon()}`} />
        {getButtonText()}
      </Button>
    </div>
  );
};

ScoringButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  coiUpdateInProgress: PropTypes.bool.isRequired,
  hasPendingCOI: PropTypes.bool.isRequired,
  trainingCompleted: PropTypes.bool.isRequired,
  handleStartScoring: PropTypes.func.isRequired,
};

export default ScoringButton;
